export default [
  { key: 'NOME_CLIENTE', value: 'Nome do cliente' },
  { key: 'USUARIO_CLIENTE', value: 'Nome de usuário do cliente' },
  { key: 'CPF_CLIENTE', value: 'Número do cadastro de pessoa física' },
  { key: 'EMAIL_CLIENTE', value: 'E-mail do cliente' },
  { key: 'CELULAR_CLIENTE', value: 'Celular do cliente' },
  { key: 'DATA_NASCIMENTO_CLIENTE', value: 'Data de nascimento do cliente' },
  { key: 'DATA_CADASTRO_CLIENTE', value: 'Data de cadastro do cliente' },
  { key: 'LOGRADOURO_CLIENTE', value: 'Logradouro e número predial do cliente' },
  { key: 'BAIRRO_CLIENTE', value: 'Bairro do cliente' },
  { key: 'CIDADE_CLIENTE', value: 'Município do cliente' },
  { key: 'UF_CLIENTE', value: 'Estado (UF) do cliente' },
  { key: 'CEP_CLIENTE', value: 'Código de endereçamento postal do cliente' },
  { key: 'TIPO_CONTA_CLIENTE', value: 'Tipo de conta bancária do cliente' },
  { key: 'SITUACAO_CLIENTE', value: 'Situação do cliente' },
  { key: 'BANCO_CLIENTE', value: 'Nome do banco da conta principal do cliente' },
  { key: 'CONTA_BANCO_CLIENTE', value: 'Número da conta principal do cliente' },
  { key: 'AGENCIA_BANCO_CLIENTE', value: 'Agência da conta principal do cliente' },
  { key: 'CODIGO_PROMOCIONAL_CLIENTE', value: 'Valor do código promocional do cliente' },
  { key: 'PRODUTO_PEDIDO', value: 'Produto de uma compra' },
  { key: 'IMAGEM_PRODUTO_PEDIDO', value: 'Imagem do produto de uma compra' },
  { key: 'VALOR_PRODUTO_PEDIDO', value: 'Valor do produto de uma compra' },
  { key: 'QTD_PRODUTO_PEDIDO', value: 'Quantidade de produtos em uma compra' },
  { key: 'CÓD_UTILIZAÇÃO_PRODUTO', value: 'Código de utilização de um produto comprado pelo cliente' },
  { key: 'DATA_PAGAMENTO_PEDIDO', value: 'Data de pagamento do pedido de um cliente' },
  { key: 'VALOR_TOTAL_PEDIDO', value: 'Valor total de um pedido' },
  { key: 'TAXA_PEDIDO', value: 'Valor da taxa de um pedido' },
  { key: 'VALOR_SUBTOTAL_PEDIDO', value: 'Valor do subtotal de um pedido' },
  { key: 'MULTA_JUROS_ATRASADO', value: 'Valor de juros e multa de um pagamento de conta' },
  { key: 'PDF_COMPROVANTE_PEDIDO', value: 'URL com o PDF do comprovante de um pedido' },
  { key: 'TOKEN_RECUPERAR_SENHA', value: 'URL com o token de recuperação de senha para um administrador' },
  { key: 'PIN_RECUPERAR_SENHA', value: 'PIN enviado ao cliente para recuperação da senha' },
  { key: 'RECUPERAR_PIN_SEGURANÇA', value: 'PIN enviado ao cliente para recuperação do PIN de segurança' },
  { key: 'VALOR_BOLETO_CASH_IN', value: 'Valor do boleto de cash in solicitado pelo cliente' },
  { key: 'VALOR_TRANSFERENCIA_CASH_IN', value: 'Valor da transferência de cash in solicitada pelo cliente' },
  { key: 'TAXA_BOLETO_CASH_IN', value: 'Valor da taxa de cash in via boleto' },
  { key: 'TAXA_TRANSFERENCIA_CASH_IN', value: 'Valor de taxa de cash in via transferência bancária' },
  { key: 'PDF_BOLETO_CASH_IN', value: 'URL com o PDF do boleto de cash in' },
  { key: 'CODBARRAS_BOLETO_CASH_IN', value: 'Código de barras do boleto de um cash in solicitado pelo cliente' },
  { key: 'REMETENTE_TRANSFERENCIA_CONTACARD', value: 'Remetente de uma transferência entre contas ContaCard' },
  { key: 'VALOR_TRANSFERENCIA_CONTACARD', value: 'Valor de taxa de cash in via transferência bancária' },
  { key: 'DESTINATARIO_TRANSFERENCIA_CONTACARD', value: 'Destinatário de uma transferência entre contas ContaCard' },
  { key: 'TAXA_TRANSFERENCIA_CONTACARD', value: 'Valor de taxa de cash in via transferência bancária' },
  { key: 'COMPROVANTE_TRANSFERENCIA_CONTACARD', value: 'URL com o PDF do comprovante de uma transferência ContaCard' },
];
